import { LoyaltyType } from "./loyalty-type.enum";
import { LoyaltyStatus } from "./loyalty-status.model";

export class LottoState extends LoyaltyStatus{

    constructor(o?: Partial<LottoState>){
        o = o || {};
        super(o);
        this.type = LoyaltyType.LOTTO;
    }
}